const DEFAULT_API_BASE_URL = "https://alwinowitch-api-v2.timex385.workers.dev";

function normalizeApiBaseUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) {
    return "";
  }

  // Cloudflare UI vars are often entered without protocol.
  const withProtocol = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;

  try {
    const parsed = new URL(withProtocol);
    return parsed.origin;
  } catch {
    return "";
  }
}

const API_BASE_URL =
  normalizeApiBaseUrl(process.env.REACT_APP_API_URL) ||
  normalizeApiBaseUrl(DEFAULT_API_BASE_URL);

export function buildApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (!API_BASE_URL) {
    return normalizedPath;
  }

  return `${API_BASE_URL}${normalizedPath}`;
}
